import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createAirline } from "../../api/apiAirlines";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateAirline = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createAirlineAction, isPending } = useMutation({
        mutationFn: createAirline,
        onSuccess: (res) => {
            const message = res?.message || "Airline created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
            navigate("/airlines");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create airline");
        },
    });

    return { createAirline: createAirlineAction, isPending };
};

export default useCreateAirline;
